import { Module } from 'vuex';
import { IRootState, client } from '@/store';
import { IProposal, IPageParams, ICRUDResponse } from '@/models';

export interface IProposalState {
  entities: Record<string, IProposal>;
  currentPage: number[];
  pageParams: Partial<IPageParams>;
  loading: boolean;
}

export const proposal: Module<IProposalState, IRootState> = {
  namespaced: true,
  state: {
    entities: {},
    currentPage: [],
    pageParams: {
      per_page: 10,
      current_page: 1
    },
    loading: true
  },
  actions: {
    pushMessage({ commit }, payload) {
      commit('pushMessage', payload);
    },
    setPageParams({ commit, dispatch }, payload) {
      commit('setPageParams', payload);
      dispatch('getEntities')
    },
    getEntities({ commit, rootState }) {
      commit('setLoading', true)
      const params: Record<string, string> = {};
      if (rootState.tableFilters?.params?.hasOwnProperty('proposal')) {
        // @ts-ignore
        for (const [key, value] of Object.entries(rootState.tableFilters.params.proposal)) {
          // @ts-ignore
          if (value && value.length) {
            // @ts-ignore
            params[key] = Array.isArray(value) ? value.join(',') : value
          }
        }
      }
      // @ts-ignore
      const sort = rootState.tableFilters.options.proposal.sortBy.map((item, index) => {
        // @ts-ignore
        return [item, rootState.tableFilters.options.proposal.sortDesc[index] ? 'desc' : 'asc']
      })
      client
        // @ts-ignore
        .get<ICRUDResponse<IProposal[]>>('proposal', { params: { ...params, per_page: rootState.tableFilters.options.proposal.itemsPerPage, page: rootState.tableFilters.options.proposal.page, sort } })
        .then(({ data: { data, ...pageParams } }) => {
          commit('setEntities', { entities: data });
          commit('setPageParams', pageParams);
          commit('setLoading', false)
        });
    },
    async getEntity({ commit }, id) {
      const { data } = await client
        .get<ICRUDResponse<IProposal>>(`proposal/${id}`)
      return data
    },
    createEntity({ dispatch, rootState }, entity: Omit<IProposal, 'id'>) {
      const id = (rootState as any).user.currentUser.id
      return client
        .post('proposal', { ...entity, creator_id: id })
        .then(({ data }) => {
          dispatch('getEntities');
          return data;
        });
    },
    deleteEntity({ dispatch }, entity: IProposal) {
      return client
        .delete(`proposal/${entity.id}`)
        .then(() => dispatch('getEntities'));
    },
    async updateEntity({ dispatch }, entity: IProposal) {
      const { data } = await client
        .put(`proposal/${entity.id}`, entity)
      return data
    },
    deleteEntities({ commit, dispatch }, entities: IProposal[]) {
      commit('setLoading', true);
      const arr = entities.flatMap(({ id }) => id);

      return client.post(`destroy/proposal`, arr).then(() => {
        dispatch('getEntities');
        commit('setLoading', false);
        return;
      });
    },
  },
  mutations: {
    setLoading(state, loading: boolean) {
      state.loading = loading;
    },
    pushMessage(state, payload) {
      const item = Object.values(state.entities).find(({ id }) => id === payload.id)
      item?.chat?.messages.push(payload.data)
    },
    setEntities(state, { entities, push = false }) {
      if (push) {
        state.entities = [...Object.values(state.entities), ...entities].reduce(
          (acc, item) => ({ ...acc, [item.id]: item }),
          {},
        );
      }
      else {
        state.entities = entities.reduce(
          //@ts-ignore
          (acc, item) => ({ ...acc, [item.id]: item }),
          {},
        );
      }
      //@ts-ignore
      state.currentPage = entities.map((entity) => entity.id);
    },
    setPageParams(state, pageParams: Omit<ICRUDResponse<IProposal[]>, 'data'>) {
      state.pageParams = pageParams;
    }
  },
  getters: {
    entitiesSlice({ currentPage, entities }) {
      return currentPage.map((id) => entities[id]);
    },
  },
};
